import { makeRequest } from "@/util";
import { LoadedConsentManagementInfo } from "@/types/global";
import { ConsentManagementSlug, invalidateQuery } from "@/api";

export type createConsentManagementConfigRequest = {
  type: ConsentManagementSlug;
  enabled: boolean;
  categoryMapping: Record<string, string>;
  consentMapping: Record<string, string>;
  consentModel: string;
  freshpaintConfig?: any; // Freshpaint-specific configuration
};

type upsertConsentManagementConfigResponse = {
  config: LoadedConsentManagementInfo;
};

export async function createConsentManagementConfig(
  payload: createConsentManagementConfigRequest,
) {
  const res = await makeRequest<upsertConsentManagementConfigResponse>(
    "create_consent_management_config",
    payload,
  );

  await invalidateQuery(["get_consent_management_configs"]);
  await invalidateQuery([
    "get_consent_management_config_versions",
    { type: payload.type },
  ]);
  return res.data;
}
